import {SessionService} from './../../../../services/session';
import {Component} from '@angular/core';
import {ModalController} from 'ionic-angular';
import {AchievementPage} from './achievement/achievement';
import {AchievementsService} from '../../../../services/achievements';

@Component({
  selector: 'app-achievements',
  templateUrl: 'achievements.html'
})
export class AchievementsComponent {

  constructor(public sessionService: SessionService,
              public achievementsService: AchievementsService,
              public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    window['page'] = 'AchievementsPage'; // for GA
    this.achievementsService.getAchievements()
      .catch(err => {
        this.sessionService.reportError(
          'achievementsPage',
          'ionViewDidLoad()',
          err
        );
      })
  }

  goToAchievement(achievement) {
    if (achievement.progress === 1) {
      this.modalCtrl.create(
        AchievementPage,
        {achievement: achievement},
        {cssClass: 'smaller-modal'}
      ).present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/my-classes/achievements/achievements.ts